import { render, staticRenderFns } from "./school-event.vue?vue&type=template&id=5f5442ea&scoped=true"
import script from "./school-event.vue?vue&type=script&lang=js"
export * from "./school-event.vue?vue&type=script&lang=js"
import style0 from "./school-event.vue?vue&type=style&index=0&id=5f5442ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5442ea",
  null
  
)

export default component.exports